import { css } from "@emotion/react";

import { CheckCircleIcon, colors } from "@dotnet/telematics-design-system";

import { svgFontSize } from "shared/styles/styleFunctions";

import { SingleValidationProps } from "./types";

const SingleValidation = ({ isActive, ruleName }: SingleValidationProps) => {
    const { gray900, green600, textDisabled } = colors;

    return (
        <div
            css={css({
                padding: "2px 0"
            })}
        >
            <div
                css={css({
                    display: "flex",
                    alignItems: "center",
                    alignSelf: "flex-start",
                    height: "20px"
                })}
            >
                <CheckCircleIcon
                    css={css({
                        color: isActive ? green600 : textDisabled,
                        ...svgFontSize(16)
                    })}
                />
            </div>

            <span
                css={css({
                    color: gray900,
                    fontSize: "14px",
                    fontWeight: "500",
                    lineHeight: "20px",
                    letterSpacing: "0.1px",
                    marginLeft: "8px"
                })}
            >
                {ruleName}
            </span>
        </div>
    );
};

export default SingleValidation;
